import { useQuery } from '@tanstack/vue-query';
import { notEmpty } from '~/utils';

export type UseProgrammesQueryOptions = {
	enabled?: MaybeRef<boolean>;
	merchantId: MaybeRef<string | undefined>;
};

export const useProgrammesQuery = (options: UseProgrammesQueryOptions) => {
	const { $api } = useNuxtApp();

	const enabled = computed(() =>
		unref(options.enabled) !== false && !!unref(options.merchantId),
	);

	const query = useQuery({
		queryKey: ['programmes', options.merchantId],
		queryFn: async () => {
			const { data } = await $api.GET('/programmes', {
				params: {
					query: {
						merchantId: unref(options.merchantId)!,
					},
				},
			});

			return data
				?.filter(notEmpty);
		},
		enabled,
	});

	return query;
};
